








import {Component, Prop, Vue} from "vue-property-decorator";
import {DeviceConfiguration} from "../../../types/core";

@Component
export default class ConfigurationList extends Vue {
  @Prop({ default: [],  type: Array}) deviceConfigurationList!: DeviceConfiguration[];
  @Prop({ default: () => {}, type: Object}) bus!:Vue;


  mounted() {
  }
}
